import React from 'react';
import {
  components,
  IndicatorProps,
  Props as ReactSelectProps,
} from 'react-select';
import StyledReactSelect from './style';

interface LabelValueI {
  label: string;
  value: string;
  error?: boolean;
}

const DropdownIndicator = (props: IndicatorProps<LabelValueI, false>) => {
  return <components.DropdownIndicator {...props} />;
};

const Select = (props: ReactSelectProps): React.ReactElement => (
  <StyledReactSelect
    isSearchable={false}
    dropdownIndicator={DropdownIndicator}
    styles={{
      indicatorSeparator: (): React.CSSProperties => ({ display: 'none' }),
      control: (provided: React.CSSProperties): React.CSSProperties => {
        return {
          ...provided,
          backgroundColor: `#f8f8f8`,
          border: 0,
        };
      },
    }}
    {...props}
  />
);

export default Select;
